import React, { useEffect, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { navItems } from '../data/company';
import Logo from './Logo';
import Icon from './Icon';

export default function Navbar() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => { setOpen(false); }, [pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <header className="nav">
      <div className="container nav__inner">
        <Link to="/" className="nav__brand" aria-label="Sheba Digital Limited home">
          <Logo light />
        </Link>
        <nav className={`nav__links ${open ? 'is-open' : ''}`} aria-label="Main">
          {navItems.map((item) => (
            <NavLink key={item.id} to={item.route} end className={({ isActive }) => (isActive ? 'is-active' : '')}>
              {item.label}
            </NavLink>
          ))}
          <Link to="/contact" className="btn btn--primary nav__cta">Get In Touch</Link>
        </nav>
        <button className="nav__toggle" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} onClick={() => setOpen(!open)}>
          <Icon name={open ? 'close' : 'menu'} size={26} />
        </button>
      </div>
    </header>
  );
}
